var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as React from 'react';

import IconInfo from '../../icons/general/IconInfo';
import Tooltip from '../tooltip';

var InfoIconWithTooltip = function InfoIconWithTooltip(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        iconProps = _ref.iconProps,
        tooltipText = _ref.tooltipText;
    return React.createElement(
        'span',
        { key: 'infoIcon', className: className + ' tooltip-icon-container' },
        React.createElement(
            Tooltip,
            { position: 'top-center', text: tooltipText },
            React.createElement(
                'span',
                { className: 'info-icon-container' },
                React.createElement(IconInfo, _extends({ height: 16, width: 16 }, iconProps))
            )
        )
    );
};

InfoIconWithTooltip.propTypes = {
    className: PropTypes.string,
    iconProps: PropTypes.object,
    tooltipText: PropTypes.node.isRequired
};
export default InfoIconWithTooltip;
import PropTypes from 'prop-types';